import React, { Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";

import FlyoutTrigger from "./FlyoutTrigger";
import FlyoutHeader from "./FlyoutHeader";
import FlyoutContent from "./FlyoutContent";
import FlyoutActions from "./FlyoutActions/FlyoutActions";

interface Props {
    children: React.ReactNode;
    isOpen?: boolean;
    onClose: () => void;
}

const Flyout = ({ children, isOpen, onClose }: Props) => (
    <Transition.Root show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-flyoutPanels" onClose={onClose}>
            <Transition.Child
                as={Fragment}
                enter="ease-in-out duration-500"
                enterFrom="opacity-0"
                enterTo="opacity-100"
                leave="ease-in-out duration-500"
                leaveFrom="opacity-100"
                leaveTo="opacity-0"
            >
                <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed inset-0 overflow-hidden">
                <div className="absolute inset-0 overflow-hidden">
                    <div className="pointer-events-none fixed inset-y-0 right-0 flex max-w-full pl-10">
                        <Transition.Child
                            as={Fragment}
                            enter="transform transition ease-in-out duration-500 sm:duration-700"
                            enterFrom="translate-x-full"
                            enterTo="translate-x-0"
                            leave="transform transition ease-in-out duration-500 sm:duration-700"
                            leaveFrom="translate-x-0"
                            leaveTo="translate-x-full"
                        >
                            <Dialog.Panel className="pointer-events-auto w-screen max-w-md">
                                <div data-test="flyout-wrap" className="flex flex-col h-full bg-white shadow-xl">
                                    {children}
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </div>
        </Dialog>
    </Transition.Root>
);

Flyout.Trigger = FlyoutTrigger;
Flyout.Header = FlyoutHeader;
Flyout.Content = FlyoutContent;
Flyout.Actions = FlyoutActions;

export default Flyout;
